<template>
  <b-container
    class="vh-100 d-flex justify-content-center align-items-center flex-column"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      style="background: none; display: block; shape-rendering: auto;"
      width="200px"
      height="200px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        r="0"
        fill="none"
        stroke="#bcbe4f"
        stroke-width="2"
      >
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="1s"
          values="0;40"
          keyTimes="0;1"
          keySplines="0 0.2 0.8 1"
          calcMode="spline"
          begin="0s"
        />
        <animate
          attributeName="opacity"
          repeatCount="indefinite"
          dur="1s"
          values="1;0"
          keyTimes="0;1"
          keySplines="0.2 0 0.8 1"
          calcMode="spline"
          begin="0s"
        />
      </circle>
      <circle
        cx="50"
        cy="50"
        r="0"
        fill="none"
        stroke="#0a7142"
        stroke-width="2"
      >
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="1s"
          values="0;40"
          keyTimes="0;1"
          keySplines="0 0.2 0.8 1"
          calcMode="spline"
          begin="-0.5s"
        />
        <animate
          attributeName="opacity"
          repeatCount="indefinite"
          dur="1s"
          values="1;0"
          keyTimes="0;1"
          keySplines="0.2 0 0.8 1"
          calcMode="spline"
          begin="-0.5s"
        />
      </circle>
    </svg>
    <p class="text-center h2 font-weight-bolder pt-2">
      Payment Request Verification
    </p>
    <p class="text-center h6 font-weight-bolder pt-2">
      Please wait while verifying the payment request . . .
    </p>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PaymentRequest',

  beforeRouteEnter (to, from, next) {
    next(context => {
      if (context.currentUser?.id) {
        next({
          name: `${context.currentUser?.role || 'user'}.payment.viewing`,
          params: {
            payment: to.params.payment
          }
        })
      } else {
        next({
          name: 'shared.login',
          query: {
            redirect: to.fullPath
          }
        })
      }
    })
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })
  }
}
</script>
